"use strict";

import StandardZuschussController from "../standard_zuschuss/controller";
import {
  EventBus,
} from "../../../../../vue/client/vue/global/functions/event-bus";

class SignalZuschussController extends StandardZuschussController {
  /*@ngInject*/
  constructor($scope, $q, Foerdermodule, Foerderantrag, KFinanzierungsart, BetragsrechnerRegistry, Vertrag, $stateParams, $filter, i18n, AuthService) {
    super($scope, $q, Foerdermodule, Foerderantrag, KFinanzierungsart, BetragsrechnerRegistry, Vertrag, $stateParams, $filter, i18n, AuthService);
    this.name = "SignalZuschussController";
    this.updateOnSignal = () => {
      this._reloadPositionen();
      this._doSavecallback();
      this.Foerderantrag.one(this.modul.regel.afr_aid).customGET("zuschuss").then(
        response => {
          Object.assign(this.infoprovider, response.plain());
          this.infoprovider.gespeichert = true;
        }
      );
    };
    this.registerOrDeactiveSignalReceiver();
  }

  registerOrDeactiveSignalReceiver({ eventBusAction = "$on" } = {}) {
    const SIGNAL_EMPFANG = this.modul.regel.signal_empfang || [];
    if (!SIGNAL_EMPFANG.length) {
      return;
    }

    SIGNAL_EMPFANG.forEach(item => {
      if (item.signal_kennung && item.sender_reid) {
        EventBus[eventBusAction](`${ item.signal_kennung }_${ item.sender_reid }`, arg => this.onReceiveSignal(item.signal_kennung, arg));
      }
    });
  }

  onReceiveSignal(signal_kennung) {
    if (signal_kennung === "dynamische_mehrfachauswahl.update") {
      this.updateOnSignal();
    }
  }
}

export default SignalZuschussController;
